import { defineMessages } from "react-intl";

export const messages = defineMessages({
  checkingBidStrength: {
    id: "ads_manager.bid_strength.checking",
    defaultMessage: "Checking bid strength…",
    description: "Loading label while the oCPC bid warning threshold is fetched.",
  },
  mayNotDeliverLabel: {
    id: "ads_manager.bid_strength.may_not_deliver.label",
    defaultMessage: "May not deliver",
    description: "Bid-strength label for a bid that may not deliver reliably.",
  },
  mayNotDeliverDescription: {
    id: "ads_manager.bid_strength.may_not_deliver.description",
    defaultMessage: "Your bid may be too low to deliver reliably.",
    description: "Bid-strength guidance for a bid that may not deliver reliably.",
  },
  weakDeliveryLabel: {
    id: "ads_manager.bid_strength.weak_delivery.label",
    defaultMessage: "Weak Delivery",
    description: "Bid-strength label for a bid with potentially limited delivery.",
  },
  weakDeliveryDescription: {
    id: "ads_manager.bid_strength.weak_delivery.description",
    defaultMessage: "Your bid may deliver, but volume could be limited.",
    description: "Bid-strength guidance for a bid with potentially limited delivery.",
  },
  strongDeliveryLabel: {
    id: "ads_manager.bid_strength.strong_delivery.label",
    defaultMessage: "Strong Delivery",
    description: "Bid-strength label for a competitive bid.",
  },
  strongDeliveryDescription: {
    id: "ads_manager.bid_strength.strong_delivery.description",
    defaultMessage: "Your bid is likely competitive for this ad group.",
    description: "Bid-strength guidance for a competitive bid.",
  },
});
